// Classes escritas por extenso: o Tailwind só gera o CSS de nomes que consegue
// encontrar literalmente no código, então nada de montar `bg-${cor}-100`.
const BADGE = {
  red: "bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300",
  orange: "bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-300",
  amber: "bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300",
  emerald: "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-300",
  gray: "bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300",
};

export const PRIORITY_CONFIG = {
  critico: {
    label: "Aja agora",
    badge: "bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300",
    bar: "bg-red-500",
    edge: "border-l-4 border-red-500",
  },
  atencao: {
    label: "Atenção",
    badge: "bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300",
    bar: "bg-amber-500",
    edge: "border-l-4 border-amber-500",
  },
  estavel: {
    label: "Estável",
    badge: "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-300",
    bar: "bg-emerald-500",
    edge: "border-l-4 border-emerald-500",
  },
};

export const RISK_CONFIG = {
  critico: { label: "Risco crítico", badge: BADGE.red },
  alto: { label: "Risco alto", badge: BADGE.orange },
  medio: { label: "Risco médio", badge: BADGE.amber },
  baixo: { label: "Risco baixo", badge: BADGE.emerald },
};

export const SATISFACTION_CONFIG = {
  insatisfeito: { label: "Insatisfeito", badge: BADGE.red },
  neutro: { label: "Neutro", badge: BADGE.gray },
  satisfeito: { label: "Satisfeito", badge: BADGE.emerald },
  desconhecido: { label: "Satisfação desconhecida", badge: BADGE.gray },
};

export const RESOLUTION_CONFIG = {
  pendente: { label: "Não resolvida", badge: BADGE.red },
  parcial: { label: "Resolução parcial", badge: BADGE.amber },
  resolvida: { label: "Resolvida", badge: BADGE.emerald },
  sem_dados: { label: "Sem dados de resolução", badge: BADGE.gray },
};

export const DIRECTION_CONFIG = {
  escalando: { label: "Escalando", badge: BADGE.red },
  abandonada: { label: "Abandonada", badge: BADGE.orange },
  estagnada: { label: "Estagnada", badge: BADGE.amber },
  avançando: { label: "Avançando", badge: BADGE.emerald },
  resolvida: { label: "Resolvida", badge: BADGE.emerald },
  indefinida: { label: "Direção indefinida", badge: BADGE.gray },
};

export const describe = (config, value) =>
  config[value] || { label: value || "—", badge: BADGE.gray };

export const scoreColor = (score) => {
  if (score === null || score === undefined) return "text-gray-400";
  if (score <= 4) return "text-red-600 dark:text-red-400";
  if (score <= 6) return "text-amber-600 dark:text-amber-400";
  return "text-emerald-600 dark:text-emerald-400";
};

export const formatScore = (score) =>
  score === null || score === undefined ? "—" : score.toFixed(1).replace(".", ",");

export const formatPhone = (value) => {
  const digits = String(value || "").replace(/\D/g, "");
  if (!digits) return "";
  const national = digits.startsWith("55") ? digits.slice(2) : digits;
  if (national.length < 10 || national.length > 11) return digits;
  const number = national.slice(2);
  const split = number.length === 9 ? 5 : 4;
  return `(${national.slice(0, 2)}) ${number.slice(0, split)}-${number.slice(split)}`;
};

// Contatos importados do WhatsApp costumam vir com o JID no lugar do nome
// ("5511956392652@c.us"). Nesse caso o telefone formatado é mais legível.
export const contactLabel = (contact) => {
  const name = (contact?.name || "").trim();
  const looksLikeId = !name || name.includes("@") || /^\+?[\d\s()-]+$/.test(name);
  if (!looksLikeId) return name;
  return formatPhone(contact?.phoneNumber || name) || "Sem contato";
};

export const relativeTime = (date) => {
  if (!date) return "—";
  const minutes = Math.round((Date.now() - new Date(date).getTime()) / 60000);
  if (minutes < 60) return `há ${Math.max(minutes, 1)} min`;
  if (minutes < 1440) return `há ${Math.floor(minutes / 60)} h`;
  const days = Math.floor(minutes / 1440);
  return days === 1 ? "há 1 dia" : `há ${days} dias`;
};
